import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface QuestionAdvancedSettingsProps {
  orderIndex: number;
  onOrderIndexChange: (value: number) => void;
  isRequired: boolean;
  onRequiredChange: (checked: boolean) => void;
  isReverseScored: boolean;
  onReverseScoredChange: (checked: boolean) => void;
}

export const QuestionAdvancedSettings = ({
  orderIndex,
  onOrderIndexChange,
  isRequired,
  onRequiredChange,
  isReverseScored,
  onReverseScoredChange,
}: QuestionAdvancedSettingsProps) => {
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="order_index">Order Index</Label>
          <Input
            id="order_index"
            type="number"
            value={orderIndex}
            onChange={(e) => onOrderIndexChange(parseInt(e.target.value))}
            min={1}
          />
        </div>

        <div className="flex items-center space-x-2 pt-6">
          <Switch
            id="is_required"
            checked={isRequired}
            onCheckedChange={onRequiredChange}
          />
          <Label htmlFor="is_required">Required Question</Label>
        </div>
      </div>

      <div className="space-y-2">
        <div className="flex items-center space-x-2">
          <Switch
            id="is_reverse_scored"
            checked={isReverseScored}
            onCheckedChange={onReverseScoredChange}
          />
          <Label htmlFor="is_reverse_scored">Reverse Scored Question</Label>
        </div>
        <p className="text-sm text-muted-foreground">
          Enable for negatively worded questions where higher scores indicate lower agreement (e.g., "If you make a mistake, it is often held against you")
        </p>
      </div>
    </>
  );
};

export default QuestionAdvancedSettings;

